import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import { Config } from '../../common/config';
import { fetchCodeDetailList } from '../../common/fetchCodeDetailList';
import AlertModal from '../../components/alertModal';
import SmsVerifyModal from '../../components/SmsVerifyModal';
import LeftMenu from '../../components/leftMenu';
import {
  getFormattedDateTime,
  getErrorMessage,
  isSuccessResponse,
} from '../../components/utils';
// import { getPostcode } from '../../components/zip';
import { getPostcodeSetters } from '../../components/zip';
import translations from '../../data/translation';
import useAxiosFetch from '../../hooks/useAxiosFetch'; // 실제 경로에 맞게 수정
import useStoreNo from '../../hooks/useStoreNo';
import qrStyles from '../../css/admin/QR.module.css';
import {
  getGiftQrStickerStrings,
  buildChannelStoreQrStickerDataUrl,
} from '../../utils/giftQrStickerCanvas';
import storeQrFrameBox from '../../images/storeQrFrameBox.png';

/** 인쇄 팝업 HTML에 문자열을 꽂아 넣기 전 이스케이프(상점명 등 사용자 입력 방어) */
function escapeHtml(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/**
 * DB의 phone 값을 sms1/sms2/sms3 입력칸 3개로 분해한다.
 * 저장은 'sms1-sms2-sms3' 형태로 하지만, DB에는 하이픈 없는 순수 숫자로 들어있는 값이 있어
 * (예: 024261011) split('-')만으로는 첫 칸에 전체가 몰리는 문제가 있었다 — 하이픈 유무 둘 다 처리.
 * 서울(02) 지역번호는 2자리, 나머지 지역번호/휴대폰은 3자리로 간주하는 통상 규칙을 따른다.
 */
function splitPhoneDigits(phone) {
  if (!phone) return ['', '', ''];
  if (phone.includes('-')) {
    const parts = phone.split('-');
    return [parts[0] || '', parts[1] || '', parts[2] || ''];
  }
  const d = phone.replace(/\D/g, '');
  if (d.startsWith('02')) {
    if (d.length === 9) return [d.slice(0, 2), d.slice(2, 5), d.slice(5, 9)];
    if (d.length === 10) return [d.slice(0, 2), d.slice(2, 6), d.slice(6, 10)];
  } else {
    if (d.length === 10) return [d.slice(0, 3), d.slice(3, 6), d.slice(6, 10)];
    if (d.length === 11) return [d.slice(0, 3), d.slice(3, 7), d.slice(7, 11)];
  }
  // 예상 밖 길이 — 기존 동작(첫 칸에 전체)으로 폴백.
  return [d, '', ''];
}

export default function StoreManage() {
  var script = document.createElement('script');
  script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

  document.head.appendChild(script);
  const { fetchData } = useAxiosFetch();
  const navigate = useNavigate();

  const userInfo = useSelector(state => state.userInfo);
  const language = useSelector(state => state.language.language);
  const t = translations[language];
  const storeNo = useStoreNo();

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const [storeData, setStoreData] = useState({});

  let phone = '';

  const [detailAddr, setDetailAddr] = useState('');
  const [regDttm, setRegDttm] = useState('');
  const [updDttm, setUpdDttm] = useState('');
  const [sms1, setSms1] = useState('');
  const [sms2, setSms2] = useState('');
  const [sms3, setSms3] = useState('');
  const [biz1, setBiz1] = useState('');
  const [biz2, setBiz2] = useState('');
  const [biz3, setBiz3] = useState('');
  // Inline validation error messages
  const [phoneError, setPhoneError] = useState('');
  const [accountNoError, setAccountNoError] = useState('');
  const [accountHolderError, setAccountHolderError] = useState('');
  const [bizError, setBizError] = useState('');
  const [, setSmsP1] = useState('');
  const [, setSmsP2] = useState('');
  const [, setSmsP3] = useState('');
  const [bankData, setBankData] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [imageFileName, setImageFileName] = useState(null);
  const [imageError, setImageError] = useState('');
  const [bizCertFileObj, setBizCertFileObj] = useState(null);
  const [bizCertError, setBizCertError] = useState('');
  const [isPhoneChecked, setIsPhoneChecked] = useState(false);
  const [isAddrChecked, setIsAddrChecked] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [addr, setAddr] = useState('');
  const [isBizLookupLoading, setIsBizLookupLoading] = useState(false);
  const [bizLookupMessage, setBizLookupMessage] = useState('');
  // 사업자번호를 다시 조회하면 계좌 실명 조회도 다시 받아야 한다
  const [needAccountRevalidation, setNeedAccountRevalidation] = useState(false);
  // 이번 수정에서 법인 계좌 인증을 통과한 경우에만 예금주(법인명)를 직접 입력할 수 있다
  const [corpAccountVerified, setCorpAccountVerified] = useState(false);
  const [isBizLookupSuccess, setIsBizLookupSuccess] = useState(null);

  // 계좌 SMS 인증 상태
  const [smsModalOpen, setSmsModalOpen] = useState(false);

  const selectedBizType = storeData.bizType || 'BT001';
  const isIndividualBizType = selectedBizType === 'BT001';

  const bizTypeOptions = [
    { value: 'BT001', label: t.storeBizTypeIndividual },
    { value: 'BT002', label: t.storeBizTypeSoleProprietor },
    { value: 'BT003', label: t.storeBizTypeCorporation },
  ];

  const normalizeUrl = url => {
    if (!url) {
      return '';
    }
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  };

  const qrDownloadRef = useRef(null);
  // 인쇄·다운로드 공용 고해상도 QR 원본(화면엔 안 보임, 71px 화면용 canvas를 그대로 확대하면
  // 모듈 경계가 뭉개진다) — 인쇄 팝업의 <img> 소스이자 buildQrStickerDataUrl 의 QR 소스로 쓴다.
  const qrPrintSourceRef = useRef(null);
  const getQrPrintSourceCanvas = () => {
    return qrPrintSourceRef.current?.querySelector('canvas');
  };

  // [APP-FORK] QR 은 항상 uuid 스킴(백엔드 조립: {SHOPUSER_APP_URL}/app/link/store/{uuid}).
  //   ★도메인/UA 로 분기하지 않는다 — QR 은 누가 스캔할지 모른다(외부 카메라/앱 스캐너 모두).
  //   ★웹URL 폴백(?selfverify)을 두지 않는다 — 숫자 PK 를 노출하고, 무엇보다 조용히 성립해
  //     잘못된 QR 이 배포돼도 아무도 모른다. 값이 없으면 QR 을 안 그리고 안내를 띄운다.
  //   ※ roles 에 'user' 가 포함된 계정은 백엔드가 qrSchemeValue 를 지운다
  //     (naegift-api store.service.ts:601) → 그 경우 QR 미표시가 의도된 동작.
  const qrValue = storeData.qrSchemeValue || '';
  // 채널 "전체상점QR" 7x10 카드와 동일한 문구 — 화면 미리보기와 다운로드/인쇄 스티커가
  // 서로 다른 문구로 어긋나지 않도록 한 곳(getGiftQrStickerStrings)에서만 만든다.
  const qrSticker = getGiftQrStickerStrings(language, storeData.storeName);

  const buildQrStickerDataUrl = async () => {
    // 300dpi로 내보내므로(giftQrStickerCanvas.js PHYSICAL_DPI) 화면용 71px 캔버스 대신
    // 인쇄용 고해상도 오프스크린 캔버스를 소스로 써야 QR 모듈 경계가 뭉개지지 않는다.
    const canvas = getQrPrintSourceCanvas();
    if (!canvas || canvas.width === 0) {
      throw new Error('QR canvas not ready');
    }
    const sticker = getGiftQrStickerStrings(language, storeData.storeName);

    const dataUrl = await buildChannelStoreQrStickerDataUrl(canvas, {
      ...sticker,
      // 채널 "개별인쇄" 카드와 동일한 6.98cm x 6.98cm 정사각 규격
      cardPhysicalWidthCm: 6.98,
      imageFormat: 'jpeg',
    });

    if (!dataUrl || dataUrl.length < 100) {
      throw new Error('sticker export failed');
    }
    return dataUrl;
  };

  const handleDownloadQR = async () => {
    try {
      const dataUrl = await buildQrStickerDataUrl();
      const downloadLink = document.createElement('a');
      downloadLink.href = dataUrl;
      downloadLink.download = `naegift-qr-${storeData.storeNo || 'store'}.jpg`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (err) {
      console.error('QR download failed:', err);
      alert(
        language === 'en'
          ? 'Failed to save QR. Please try again.'
          : 'QR 저장에 실패했습니다. 다시 시도해 주세요.'
      );
    }
  };

  // 인쇄는 다운로드(JPEG 한 장)와 달리 카드를 통째로 이미지로 굳히지 않는다 —
  // 채널 "전체상점QR" 원본 코드(storeEntryQrPrint.js)처럼 실제 HTML/CSS(웹폰트 텍스트,
  // CSS 배경)로 그려야 인쇄 시 글자가 폰트 그대로 선명하게 나온다. QR 자체만 비트맵이라
  // <img>로 넣되, 화면용 71px 캔버스 대신 고해상도 오프스크린 캔버스(qrPrintSourceRef)를
  // 소스로 써서 확대 인쇄 시에도 모듈 경계가 뭉개지지 않게 한다.
  const handlePrintQR = () => {
    const qrCanvas = getQrPrintSourceCanvas();
    if (!qrCanvas || qrCanvas.width === 0) {
      alert(
        language === 'en'
          ? 'QR is not ready yet. Please try again.'
          : 'QR 코드가 아직 준비되지 않았습니다. 다시 시도해 주세요.'
      );
      return;
    }

    try {
      const qrDataUrl = qrCanvas.toDataURL('image/png');
      const title = `${qrSticker.storeName} ${qrSticker.giftLabel}`;
      const stepsHtml = qrSticker.footerSteps
        .map(
          (step, idx) =>
            `<li><span>${idx + 1}</span><p>${escapeHtml(step)}</p></li>`
        )
        .join('');

      const printContent = `<!DOCTYPE html>
<html lang="ko">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<title>${escapeHtml(title)}</title>
<style>
  * { box-sizing: border-box; }
  @font-face {
    font-family: 'YeogiOttaeJalnan';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_four@1.2/JalnanOTF00.woff') format('woff');
    font-weight: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'YeogiOttaeJalnanGothic';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_231029@1.1/JalnanGothic.woff') format('woff');
    font-weight: normal;
    font-display: swap;
  }
  html {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
  }
  body {
    font-family: 'YeogiOttaeJalnanGothic', -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif;
    margin: 0;
    background: #f5f5f5;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card {
    width: 7cm;
    height: 10cm;
    background: #FFEC00;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
  }
  .card__header {
    width: 100%;
    padding: 10px 10px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card__headerText {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
    min-width: 0;
  }
  .card__title {
    max-width: 92%;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.1;
    color: #881D99;
    text-align: center;
    font-family: 'YeogiOttaeJalnan', -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
  .card__scanText {
    font-size: 14px;
    line-height: 1.2;
    color: #000;
    text-align: center;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
  .card__qrWrap {
    width: 152px;
    height: 144px;
    position: relative;
    background: url('${storeQrFrameBox}') no-repeat center top / 100% auto;
  }
  .card__qrWrap img {
    display: block;
    width: 71px;
    margin-top: 50px;
    margin-left: 37px;
  }
  .card__footer {
    box-sizing: border-box;
    padding: 12px 0 16px;
    background: #881D99;
    width: 100%;
    height: 180px;
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    flex-wrap: wrap;
  }
  .card__footer > p {
    text-align: center;
    font-size: 14px;
    font-family: 'YeogiOttaeJalnanGothic', -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif;
    color: #FFEC00;
    width: 100%;
    margin: 0;
  }
  .card__footer ul {
    width: 200px;
    position: relative;
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  .card__footer ul li {
    width: 100%;
    height: 29px;
    border-radius: 6px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    line-height: 1;
    position: relative;
  }
  .card__footer ul li span {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 100%;
    background: #881D99;
    color: #fff;
    font-family: -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif;
    width: 15px;
    height: 15px;
    font-size: 9px;
  }
  .card__footer ul li p {
    font-family: 'YeogiOttaeJalnanGothic', -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Segoe UI", Roboto, sans-serif;
    color: #881D99;
    font-size: 12px;
    line-height: 12px;
    width: 158px;
    margin: 0;
    text-align: center;
  }
  /* 채널 "전체상점QR" 인쇄(storeEntryQrPrint.js)처럼 용지 크기 자체를 카드 규격과
     동일하게 고정해야 한다 — 지정하지 않으면 브라우저가 시스템 기본 용지(A4/Letter 등)
     기준으로 배율을 조정해서, 카드가 CSS에 적은 7x10cm보다 미세하게 크거나 작게 찍힌다. */
  @page {
    size: 7cm 10cm;
    margin: 0;
  }
  @media print {
    body { background: #fff; }
  }
</style>
</head>
<body>
  <div class="card">
    <div class="card__header">
      <div class="card__headerText">
        <div class="card__title">${escapeHtml(title)}</div>
        <div class="card__scanText">${escapeHtml(qrSticker.scanText)}</div>
      </div>
    </div>
    <div class="card__qrWrap">
      <img id="qrPrintImg" src="${qrDataUrl}" alt="QR" />
    </div>
    <div class="card__footer">
      <p>${escapeHtml(qrSticker.footerTitle)}</p>
      <ul>${stepsHtml}</ul>
    </div>
  </div>
  <script>
    (function () {
      var img = document.getElementById('qrPrintImg');
      function doPrint() {
        window.focus();
        window.print();
        window.onafterprint = function () { window.close(); };
      }
      function afterFonts() {
        if (img.complete && img.naturalWidth > 0) {
          doPrint();
        } else {
          img.onload = doPrint;
          img.onerror = function () {
            alert(${JSON.stringify(
              language === 'en'
                ? 'Failed to load QR image for print.'
                : '인쇄용 QR 이미지를 불러오지 못했습니다.'
            )});
            window.close();
          };
        }
      }
      Promise.all([
        document.fonts.load('600 16px "YeogiOttaeJalnan"'),
        document.fonts.load('400 14px "YeogiOttaeJalnanGothic"'),
      ]).catch(function () {}).then(afterFonts);
    })();
  </script>
</body>
</html>`;

      const printWin = window.open('', '_blank');
      if (!printWin) {
        alert(
          language === 'en'
            ? 'Please allow pop-ups to print.'
            : '프린트를 위해 팝업을 허용해 주세요.'
        );
        return;
      }
      printWin.document.write(printContent);
      printWin.document.close();
    } catch (err) {
      console.error('QR print failed:', err);
      alert(
        language === 'en'
          ? 'Failed to print QR. Please try again.'
          : 'QR 인쇄에 실패했습니다. 다시 시도해 주세요.'
      );
    }
  };

  const handleSocialUrlChange = (key, value) => {
    setStoreData(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const checkBusinessRegistration = async () => {
    const bizDigits = (biz1 + biz2 + biz3).replace(/\D/g, '');

    if (bizDigits.length !== 10) {
      setBizLookupMessage(t.storeBizNumberCheckEmpty);
      setIsBizLookupSuccess(false);
      return;
    }

    try {
      setIsBizLookupLoading(true);
      const response = await fetch(Config.API_BIZ_VALIDATION_STATUS, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          bNo: bizDigits,
        }),
      });

      const wrapped = await response.json();
      if (!response.ok) {
        throw new Error(
          wrapped?.message || wrapped?.resultMessage || 'FETCH_ERROR'
        );
      }
      const data = wrapped?.data;

      const firstResult = Array.isArray(data?.data) ? data.data[0] : null;
      let message = t.storeBizNumberCheckSuccess;
      let successFlag = false;

      if (firstResult) {
        const statusText = firstResult.tax_type || firstResult.b_stt || '';
        const codeText = firstResult.tax_type_cd || firstResult.b_stt_cd || '';
        const extra = [statusText, codeText].filter(Boolean).join(' ');
        successFlag = /계속/.test(statusText) || codeText === '01';

        if (successFlag) {
          message = `${t.storeBizNumberCheckSuccess} (${extra || statusText || t.continueBusiness})`;
        } else {
          message =
            extra ||
            statusText ||
            data?.status_msg ||
            t.storeBizNumberCheckFail;
        }
      } else if (data?.status_msg) {
        message = data.status_msg;
      }

      setBizLookupMessage(message);
      setIsBizLookupSuccess(successFlag);
      // 조회에 성공하면 사업자 유형도 새 번호 기준으로 갱신한다
      // (가입 화면과 동일: 가운데 두 자리 81~88 = 법인, 그 외 = 개인사업자)
      if (successFlag) {
        const middle = Number(biz2);
        // 개인/법인이 달라질 수 있으므로 기존 계좌 정보는 비우고 재인증을 요구한다
        setStoreData(prev => ({
          ...prev,
          bizType: middle >= 81 && middle <= 88 ? 'BT003' : 'BT002',
          bankCode: '',
          accountNo: '',
          accountHolder: '',
        }));
        setNeedAccountRevalidation(true);
        setCorpAccountVerified(false);
      }
    } catch (error) {
      console.error('Business registration lookup failed:', error);
      setBizLookupMessage(t.storeBizNumberCheckFail);
      setIsBizLookupSuccess(false);
    } finally {
      setIsBizLookupLoading(false);
    }
  };

  const getAdminInfoFromLocalStorage = useCallback(() => {
    try {
      const persisted = localStorage.getItem('persist:root');
      if (persisted) {
        const root = JSON.parse(persisted);
        if (root && root.userInfo) {
          const admin = JSON.parse(root.userInfo);
          if (admin && typeof admin === 'object') {
            return admin;
          }
        }
      }
    } catch (_) {}
    try {
      const raw = localStorage.getItem('userInfo');
      if (raw) {
        const admin = JSON.parse(raw);
        if (admin && typeof admin === 'object') {
          return admin;
        }
      }
    } catch (_) {}
    return userInfo || {};
  }, [userInfo]);

  const [prevPhone, setPrevPhone] = useState(null);
  const [prevAddr, setPrevAddr] = useState(null);

  useEffect(() => {
    if (isPhoneChecked) {
      setPrevPhone({ sms1, sms2, sms3 });
      const admin = getAdminInfoFromLocalStorage();
      const mobile = admin?.mobile || '';
      const match = mobile.match(/^(\d{3})-(\d{3,4})-(\d{4})$/);
      if (match) {
        setSms1(match[1]);
        setSms2(match[2]);
        setSms3(match[3]);
      }
    } else if (prevPhone) {
      setSms1(prevPhone.sms1 || '');
      setSms2(prevPhone.sms2 || '');
      setSms3(prevPhone.sms3 || '');
      setPrevPhone(null);
    }
  }, [
    isPhoneChecked,
    sms1,
    sms2,
    sms3,
    prevPhone,
    getAdminInfoFromLocalStorage,
  ]);

  useEffect(() => {
    if (isAddrChecked) {
      setPrevAddr({ zipCode, addr, detailAddr });
      const admin = getAdminInfoFromLocalStorage();
      if (admin.zipCode) setZipCode(admin.zipCode);
      if (admin.addr) setAddr(admin.addr);
      if (admin.detAddr) setDetailAddr(admin.detAddr);
    } else if (prevAddr) {
      setZipCode(prevAddr.zipCode || '');
      setAddr(prevAddr.addr || '');
      setDetailAddr(prevAddr.detailAddr || '');
      setPrevAddr(null);
    }
  }, [
    isAddrChecked,
    zipCode,
    addr,
    detailAddr,
    prevAddr,
    getAdminInfoFromLocalStorage,
  ]);

  const openModal = () => {
    if (modalInfo.actionFlag === 'del') {
      setModalInfo({
        ...modalInfo,
        actionFlag: 'del',
        isCancel: true,
        mainMsg: t.confirmDelete,
      });
    } else if (modalInfo.actionFlag === 'api') {
      setModalInfo({
        ...modalInfo,
        mainMsg: modalInfo.mainMsg || t.requestError,
      });
    }

    setModalOpen(true);
  };

  const closeModal = () => {
    if (modalInfo.actionFlag === 'del') {
      modalInfo.isCancel = false;
    }

    setModalOpen(false);
    if (modalInfo.actionFlag === 'reload') {
      window.location.reload();
    }
  };

  const doModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'del') {
      modalInfo.actionFlag = '';
      delStore();
    } else if (modalInfo.actionFlag === 'goMain') {
      navigate('/go-main');
    } else if (modalInfo.actionFlag === 'login') {
      navigate('/login');
    } else if (modalInfo.actionFlag === 'reload') {
      window.location.reload();
    }
  };

  const validatePhone = () => {
    const hasNumber1 = !isNaN(sms1);
    const hasNumber2 = !isNaN(sms2);
    const hasNumber3 = !isNaN(sms3);
    if (hasNumber1 & hasNumber2 & hasNumber3) {
      phone = sms1 + '-' + sms2 + '-' + sms3;
      return true;
    } else {
      modalInfo.mainMsg = t.storePhoneFormat;
      return false;
    }
    // }
  };
  const getBankNameByCode = code => {
    if (!code) return '';
    const bank = bankData.find(item => item.detailCode === code);
    return bank ? bank.detailCodeName : code;
  };

  const handleResetValidationState = () => {
    setAccountNoError('');
    setAccountHolderError('');
  };

  const handleOpenValidationModal = async () => {
    try {
      window.__NAEGIFT_BANK_OPTIONS__ = bankData || [];
    } catch (e) {}
    let adminName = userInfo.name || storeData.accountHolder || '';
    let birthStr = '';
    try {
      const ret = await fetchData({
        url: `${Config.API_SERVER}detail/${userInfo.id}`,
        method: 'get',
      });
      if (ret?.data?.data) {
        adminName =
          adminName || ret.data.data.adminName || ret.data.data.userName || '';
        birthStr = ret.data.data.birthday
          ? ret.data.data.birthday.slice(0, 10)
          : '';
      }
    } catch (err) {
      console.error('Error fetching admin detail:', err);
    }
    const [y, m, d] = birthStr ? birthStr.split('-') : ['', '', ''];
    // 법인(BT003)은 사업자번호로 계좌 인증(LGD_GUBUN=5), 그 외는 예금주+생년월일(LGD_GUBUN=3)
    const isCorporate = selectedBizType === 'BT003';
    const bizDigits = (biz1 + biz2 + biz3).replace(/\D/g, '');
    if (isCorporate && bizDigits.length !== 10) {
      setAccountNoError('법인 계좌 인증에는 사업자등록번호 10자리가 필요합니다.');
      return;
    }
    const params = new URLSearchParams({
      ...(isCorporate && { bizType: 'BT003', bizNo: bizDigits }),
      name: isCorporate ? '' : adminName || '',
      year: y || '',
      month: m || '',
      day: d || '',
      bankCode: storeData.bankCode || bankData[0]?.detailCode || '',
      accountNo: storeData.accountNo || '',
    });
    const base = window.location.origin;
    const url = `${base}/popup/account-validation?${params.toString()}`;
    window.open(
      url,
      'accountValidation',
      'width=420,height=660,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes'
    );
  };

  useEffect(() => {
    const handler = event => {
      const data = event?.data;
      if (!data || data.type !== 'ACCOUNT_VALIDATION_RESULT') return;
      if (data.success && data.data) {
        // SMS 인증은 조회 팝업을 열기 전에 이미 완료되었으므로 바로 반영
        setStoreData(prev => ({
          ...prev,
          bankCode: data.data.bankCode,
          accountNo: data.data.accountNo,
          // 법인 계좌 인증은 예금주를 받지 않음 — 인증 후 예금주 칸에 법인명을 직접 입력한다
          accountHolder:
            data.data.bizType === 'BT003' ? '' : data.data.accountHolder,
        }));
        setCorpAccountVerified(data.data.bizType === 'BT003');
        setNeedAccountRevalidation(false);
        setAccountNoError('');
        setAccountHolderError('');
      } else {
        setAccountNoError(data.errorMessage || t.accountValidationFailed);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  // 계좌 실명 조회 버튼 클릭 시: 조회 팝업을 열기 전에 SMS 인증부터 진행
  const handleAccountValidationClick = () => {
    handleResetValidationState();
    setSmsModalOpen(true);
  };

  // JWT refresh handled centrally in useAxiosFetch

  const getBankData = useCallback(async _newToken => {
    try {
      const list = await fetchCodeDetailList(
        Config.API_ADMIN_CODE_DETAIL,
        'NG11',
        url =>
          fetchData({
            url,
            method: 'get',
          })
      );
      setBankData(list);
    } catch (error) {
      console.error('Error getData:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = useCallback(
    async _newToken => {
      try {
        const ret = await fetchData({
          url: Config.API_SERVER + 'store/' + userInfo.storeNo,
          method: 'get',
        });

        if (ret?.data?.data) {
          setStoreData(ret.data.data.data);
          setImageFile(ret.data.data.data.thumbnailFileUrl);
          // }

          if (ret.data.data.data.phone) {
            const parts = splitPhoneDigits(ret.data.data.data.phone);

            setSmsP1(parts[0]);
            setSmsP2(parts[1]);
            setSmsP3(parts[2]);
            setSms1(parts[0]);
            setSms2(parts[1]);
            setSms3(parts[2]);
          }
          if (
            ret.data.data.data.bizNum &&
            ret.data.data.data.bizType !== 'BT001'
          ) {
            const digits = String(ret.data.data.data.bizNum).replace(/\D/g, '');
            setBiz1(digits.slice(0, 3));
            setBiz2(digits.slice(3, 5));
            setBiz3(digits.slice(5, 10));
          } else {
            setBiz1('');
            setBiz2('');
            setBiz3('');
          }
          setBizLookupMessage('');
          setIsBizLookupSuccess(null);
          if (ret.data.data.data.zipCode) {
            setZipCode(ret.data.data.data.zipCode);
            setAddr(ret.data.data.data.addr);
          }
          setDetailAddr(ret.data.data.data.detAddr || '');
          setRegDttm(getFormattedDateTime(ret.data.data.data.regDttm));
          setUpdDttm(getFormattedDateTime(ret.data.data.data.updDttm));
        }
      } catch (error) {
        console.error('Error getData:', error);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [userInfo.storeNo]
  );
  const checkStoreData = () => {
    // ("checkStoreData");

    if (!storeData.storeName) {
      modalInfo.mainMsg = t.storeNameRequired;
      return false;
    }
    const validPhone = validatePhone();
    if (!validPhone) return false;
    if (!phone) {
      modalInfo.mainMsg = t.storePhoneRequired;
      return false;
    }
    if (!storeData.zipCode) {
      modalInfo.mainMsg = t.storeAddrRequired;
      return false;
    }
    if (needAccountRevalidation) {
      modalInfo.mainMsg =
        '사업자등록번호를 다시 조회했습니다. 계좌 실명 조회를 다시 진행해 주세요.';
      return false;
    }
    if (!storeData.bankCode) {
      modalInfo.mainMsg = t.storeBankRequired;
      return false;
    }
    if (!storeData.accountNo) {
      modalInfo.mainMsg = t.storeAccountNoRequired;
      return false;
    } else {
      const hasNumber = !isNaN(storeData.accountNo);
      if (!hasNumber) {
        modalInfo.mainMsg = t.storeAccountNoFormat;
        return false;
      }
    }
    if (!storeData.accountHolder) {
      modalInfo.mainMsg = t.storeAccountHolderRequired;
      return false;
    }

    if (!isIndividualBizType) {
      const hasAnyBiz = Boolean(biz1 || biz2 || biz3);
      if (hasAnyBiz) {
        if (!(biz1.length === 3 && biz2.length === 2 && biz3.length === 5)) {
          modalInfo.mainMsg = t.storeBizNumFormat;
          return false;
        }
      }

      // TODO: Re-enable business number verification requirement once lookup API stabilizes
      // if (isBizLookupSuccess !== true) {
      //   setBizLookupMessage(t.storeBizNumberCheckRequired);
      //   setIsBizLookupSuccess(false);
      //   modalInfo.mainMsg = t.storeBizNumberCheckRequired;
      //   return false;
      // }
    }

    return true;
  };

  const maskedPhone = (userInfo.mobile || '').replace(
    /(\d{3})-?(\d{3,4})-?(\d{4})/,
    (_, p1, p2, p3) => `${p1}-${'*'.repeat(p2.length)}-${p3}`
  );

  const handleSmsSend = async () => {
    if (!userInfo.mobile) throw new Error(t.smsVerifyNoMobile);
    await fetchData({
      url: `${Config.API_SERVER}profile-auth/sms/send`,
      method: 'post',
      data: {
        adminId: userInfo.id,
        mobile: userInfo.mobile,
        password: 'string',
      },
    });
  };

  const handleSmsVerify = async code => {
    const ret = await fetchData({
      url: `${Config.API_SERVER}profile-auth/sms/verify`,
      method: 'post',
      data: { adminId: userInfo.id, mobileAuthNo: Number(code) },
    });
    if (ret?.data?.data?.verifyResult) {
      // 인증 성공 후 계좌 실명 조회 팝업 오픈
      setSmsModalOpen(false);
      handleOpenValidationModal();
      return true;
    }
    return false;
  };

  const modStore = async () => {
    try {
      if (checkStoreData() === true) {
        const formData = new FormData();
        formData.append('storeName', storeData.storeName);
        formData.append(
          'representativeName',
          storeData.representativeName || ''
        );
        formData.append('phone', phone);
        if (document.getElementById('postcode').value > 0) {
          formData.append('zipCode', document.getElementById('postcode').value);
          formData.append('addr', document.getElementById('roadAddress').value);
        }
        if (detailAddr.length > 0) {
          formData.append('detAddr', detailAddr);
        }
        formData.append('bankCode', storeData.bankCode);
        formData.append('accountNo', storeData.accountNo);
        formData.append('accountHolder', storeData.accountHolder);
        const trimmedNaverUrl = (storeData.naverUrl || '').trim();
        const trimmedKakaoUrl = (storeData.kakaoUrl || '').trim();
        const trimmedInstagramUrl = (storeData.instagramUrl || '').trim();

        formData.append('naverUrl', trimmedNaverUrl || '');
        formData.append('kakaoUrl', trimmedKakaoUrl || '');
        formData.append('instagramUrl', trimmedInstagramUrl || '');
        const qc = storeData.qrStickerCount;
        formData.append(
          'qrStickerCount',
          qc === null || qc === undefined || qc === '' ? '' : String(qc)
        );
        const aic = storeData.acrylicInstallCount;
        formData.append(
          'acrylicInstallCount',
          aic === null || aic === undefined || aic === '' ? '' : String(aic)
        );
        formData.append('state', storeData.state || 'T');
        formData.append('bizType', selectedBizType);
        // 사업자등록번호 (3-2-5 결합하여 숫자만 전송)
        const bizDigits = (biz1 + biz2 + biz3).replace(/\D/g, '');
        if (!isIndividualBizType && bizDigits.length === 10) {
          formData.append('bizNum', bizDigits);
        }

        // 이미지 파일 추가

        if (imageFile) {
          if (imageFile !== storeData.thumbnailFileUrl) {
            formData.append('file', imageFileName);
          }
        }

        // 사업자등록증 파일 추가 (새로 선택된 경우에만)
        if (bizCertFileObj) {
          formData.append('bizCertFile', bizCertFileObj);
        }

        // 상점 정보 저장
        const ret = await fetchData({
          url: `${Config.API_SERVER}store/${storeData.storeNo}`,
          method: 'put',
          data: formData,
        });
        if (isSuccessResponse(ret)) {
          // 저장 성공 안내를 닫으면 새로고침해서 서버에 저장된 값으로 다시 불러온다
          setModalInfo({
            ...modalInfo,
            actionFlag: 'reload',
            mainMsg: t.modifySuccess,
          });
          setModalOpen(true);
        } else {
          setModalInfo({
            ...modalInfo,
            actionFlag: 'api',
            mainMsg: getErrorMessage(ret),
          });
          setModalOpen(true);
        }
      } else {
        setModalInfo({ ...modalInfo });
        setModalOpen(true);
      }
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        actionFlag: 'api',
        mainMsg: getErrorMessage(error?.response),
      });
      setModalOpen(true);
      console.error('Error fetching data:', error);
    }
  };

  const changeFile = e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 3 * 1024 * 1024) {
        // 3MB 이상인 경우
        e.target.value = null; // 파일 선택 취소
        setImageFile(null);
        setImageFileName(null);
        setImageError(t.imageSizeError);
      } else {
        setImageError('');
        setImageFile(URL.createObjectURL(file)); // 미리보기
        setImageFileName(file);
      }
    } else {
      setImageFile(null);
      setImageFileName(null);
      setImageError('');
    }
  };

  const changeBizCertFile = e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        e.target.value = null;
        setBizCertFileObj(null);
        setBizCertError(t.bizCertFileSizeError);
      } else {
        setBizCertError('');
        setBizCertFileObj(file);
      }
    } else {
      setBizCertFileObj(null);
      setBizCertError('');
    }
  };

  const delStore = async () => {
    try {
      const ret = await fetchData({
        url: `${Config.API_SERVER}store/${storeData.storeNo}`,
        method: 'delete',
      });
      if (isSuccessResponse(ret)) {
        navigate('/login');
      } else {
        setModalInfo({
          ...modalInfo,
          actionFlag: 'api',
          mainMsg: getErrorMessage(ret),
        });
        setModalOpen(true);
      }
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        actionFlag: 'api',
        mainMsg: getErrorMessage(error?.response),
      });
      setModalOpen(true);
      console.error('Error fetching data:', error);
    }
  };
  /*
  const pushAlarm = async () => {
    try {
      await fetchData({
        url: Config.API_SERVER + 'fcm/push',

        method: 'get',
      });
      setModalInfo({
        ...modalInfo,
        mainMsg: t.pushSendSuccess,
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        mainMsg: t.pushSendFail,
        isCancel: false,
        isConfirm: true,
      });
      setModalOpen(true);
      console.error('Error pushAlarm:', error);
    }
  };
  */
  useEffect(() => {
    getData();
    getBankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.storeNo]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
        action={doModal}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <SmsVerifyModal
        open={smsModalOpen}
        onClose={() => setSmsModalOpen(false)}
        maskedPhone={maskedPhone}
        onSend={handleSmsSend}
        onVerify={handleSmsVerify}
        t={t}
      />

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              {t.home}
            </NavLink>
          </li>
          <li>{t.storeManagement}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="store" />

          <section className="rightcontant_box">
            <h2 className="tit_01">{t.storeManagement}</h2>

            <article className="form_card contants_box_03">
              <table className="member_box">
                <tbody>
                  {!isIndividualBizType && (
                    <tr>
                      <th>{t.bizNumLabel}</th>
                      <td>
                        <div
                          style={{
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                          }}
                        >
                          <form
                            style={{
                              display: 'flex',
                              gap: '4px',
                              alignItems: 'center',
                            }}
                          >
                            <input
                              className="input_02"
                              type="text"
                              maxLength={3}
                              value={biz1}
                              onChange={e => {
                                const raw = e.target.value;
                                if (/^\d*$/.test(raw)) {
                                  setBizError('');
                                } else {
                                  setBizError(t.numbersOnly);
                                }
                                setBizLookupMessage('');
                                setIsBizLookupSuccess(null);
                                setBiz1(raw.replace(/\D/g, ''));
                              }}
                            />
                            <span>-</span>
                            <input
                              className="input_02"
                              type="text"
                              maxLength={2}
                              value={biz2}
                              onChange={e => {
                                const raw = e.target.value;
                                if (/^\d*$/.test(raw)) {
                                  setBizError('');
                                } else {
                                  setBizError(t.numbersOnly);
                                }
                                setBizLookupMessage('');
                                setIsBizLookupSuccess(null);
                                setBiz2(raw.replace(/\D/g, ''));
                              }}
                            />
                            <span>-</span>
                            <input
                              className="input_02"
                              type="text"
                              maxLength={5}
                              value={biz3}
                              onChange={e => {
                                const raw = e.target.value;
                                if (/^\d*$/.test(raw)) {
                                  setBizError('');
                                } else {
                                  setBizError(t.numbersOnly);
                                }
                                setBizLookupMessage('');
                                setIsBizLookupSuccess(null);
                                setBiz3(raw.replace(/\D/g, ''));
                              }}
                            />
                          </form>
                          <button
                            type="button"
                            className="button_05 button_gray"
                            onClick={checkBusinessRegistration}
                            disabled={isBizLookupLoading}
                          >
                            {isBizLookupLoading
                              ? t.storeBizNumberChecking
                              : t.storeBizNumberCheck}
                          </button>
                        </div>
                        {bizError && <div className="font_red">{bizError}</div>}
                        {bizLookupMessage && (
                          <div
                            style={{
                              marginTop: '6px',
                              color: isBizLookupSuccess ? '#1a7f37' : '#d9534f',
                              whiteSpace: 'pre-line',
                            }}
                          >
                            {bizLookupMessage}
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <th>{t.storeBizType}</th>
                    <td>
                      <span>
                        {bizTypeOptions.find(o => o.value === selectedBizType)
                          ?.label ?? selectedBizType}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeId}</th>
                    <td>
                      <input
                        className="input_01"
                        type="text"
                        style={{ backgroundColor: '#ddd' }}
                        disabled
                        value={storeData.storeNo ?? ''}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeName}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={64}
                          value={storeData.storeName || ''}
                          onChange={e =>
                            setStoreData({
                              ...storeData,
                              storeName: e.target.value,
                            })
                          }
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.representativeName}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          maxLength={80}
                          value={storeData.representativeName || ''}
                          onChange={e =>
                            setStoreData({
                              ...storeData,
                              representativeName: e.target.value,
                            })
                          }
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeLogo}</th>
                    <td>
                      <div className="signup_06">
                        <div className="signup_06_002">
                          {imageFile && (
                            <img
                              className="signup_img_xbtn"
                              src={imageFile}
                              alt="Selected"
                            />
                          )}
                        </div>
                        <div>
                          <form>
                            <input
                              type="file"
                              name="fileInput"
                              onChange={changeFile}
                              accept=".jpg, .jpeg, .gif, .png"
                            />
                          </form>
                          <p className="font_gray">{t.uploadFileNote}</p>
                          {imageError && (
                            <div className="font_red">{imageError}</div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.bizCertFile}</th>
                    <td>
                      <div>
                        {storeData.bizCertFileName && (
                          <p style={{ marginBottom: 4 }}>
                            {t.bizCertFileUploadedLabel}:{' '}
                            {storeData.bizCertFileUrl ? (
                              <a
                                href={storeData.bizCertFileUrl}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {storeData.bizCertFileName}
                              </a>
                            ) : (
                              storeData.bizCertFileName
                            )}
                          </p>
                        )}
                        <form>
                          <input
                            type="file"
                            name="bizCertFileInput"
                            onChange={changeBizCertFile}
                            accept=".pdf, .jpg, .jpeg, .png"
                          />
                        </form>
                        <p className="font_gray">{t.bizCertFileNote}</p>
                        {bizCertFileObj && (
                          <p style={{ marginTop: 4, fontSize: 12 }}>
                            {bizCertFileObj.name}
                          </p>
                        )}
                        {bizCertError && (
                          <div className="font_red">{bizCertError}</div>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.phoneNumber}</th>
                    <td>
                      <form>
                        <input
                          className="input_02"
                          type="text"
                          maxLength={3}
                          value={sms1}
                          onChange={e => {
                            const raw = e.target.value;
                            if (/^\d*$/.test(raw)) {
                              setPhoneError('');
                            } else {
                              setPhoneError('숫자만 입력해주세요.');
                            }
                            setSms1(raw.replace(/\D/g, ''));
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          maxLength={4}
                          value={sms2}
                          onChange={e => {
                            const raw = e.target.value;
                            if (/^\d*$/.test(raw)) {
                              setPhoneError('');
                            } else {
                              setPhoneError('숫자만 입력해주세요.');
                            }
                            setSms2(raw.replace(/\D/g, ''));
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          maxLength={4}
                          value={sms3}
                          onChange={e => {
                            const raw = e.target.value;
                            if (/^\d*$/.test(raw)) {
                              setPhoneError('');
                            } else {
                              setPhoneError('숫자만 입력해주세요.');
                            }
                            setSms3(raw.replace(/\D/g, ''));
                          }}
                        />
                        <label
                          className="check_box"
                          style={{ marginLeft: '30px' }}
                        >
                          {t.phoneSameAsAdmin}
                          <input
                            type="checkbox"
                            checked={isPhoneChecked}
                            onChange={() => setIsPhoneChecked(!isPhoneChecked)}
                          />
                          <span className="check_check"></span>
                        </label>
                      </form>
                      {phoneError && (
                        <div className="font_red">{phoneError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.address}</th>
                    <td>
                      <div className="signup_04">
                        <form>
                          <input
                            className="input_01_01"
                            style={{ backgroundColor: '#ddd' }}
                            type="text"
                            id="postcode"
                            disabled
                            placeholder={t.zipCode}
                            value={zipCode}
                          />
                          <button
                            type="button"
                            className="button_05 button_gray"
                            onClick={() =>
                              getPostcodeSetters({
                                setZipCode,
                                setAddr,
                                setDetailAddr,
                              })
                            }
                          >
                            {t.search}
                          </button>
                          <label
                            className="check_box"
                            style={{ marginLeft: '30px' }}
                          >
                            {t.phoneSameAsAdmin}
                            <input
                              type="checkbox"
                              checked={isAddrChecked}
                              onChange={() => setIsAddrChecked(!isAddrChecked)}
                            />
                            <span className="check_check"></span>
                          </label>
                          <br />
                          <input
                            className="input_03"
                            type="text"
                            id="jibunAddress"
                            disabled
                            placeholder="지번주소"
                            hidden={true}
                          />
                          <input
                            className="input_03"
                            type="text"
                            id="roadAddress"
                            disabled
                            placeholder={t.roadAddress}
                            value={addr}
                          />
                          <input
                            className="input_03"
                            type="text"
                            id="detailAddress"
                            maxLength={64}
                            placeholder={t.detailAddress}
                            value={detailAddr}
                            onChange={e => setDetailAddr(e.target.value)}
                          />
                          <input
                            className="input_03"
                            type="text"
                            id="extraAddress"
                            disabled
                            placeholder="참고항목"
                            hidden={true}
                          />
                        </form>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.selectBank}</th>
                    <td>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <input
                          className="input_01"
                          type="text"
                          disabled
                          readOnly
                          value={
                            storeData.bankCode
                              ? `${getBankNameByCode(storeData.bankCode)} (${storeData.bankCode})`
                              : '계좌 실명 조회 후 자동 입력됩니다.'
                          }
                        />
                        <button
                          type="button"
                          className="button_05 button_blue"
                          onClick={handleAccountValidationClick}
                        >
                          {t.accountValidation || '계좌 실명 조회'}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.bankAccountNumber}</th>
                    <td>
                      <div>
                        <input
                          className="input_01"
                          type="text"
                          disabled
                          readOnly
                          value={
                            storeData.accountNo
                              ? String(storeData.accountNo)
                              : '계좌 실명 조회 후 자동 입력됩니다.'
                          }
                        />
                      </div>
                      {accountNoError && (
                        <div className="font_red">{accountNoError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.accountHolder}</th>
                    <td>
                      <div>
                        {corpAccountVerified ? (
                          <>
                            <input
                              className="input_01"
                              type="text"
                              maxLength={80}
                              placeholder="법인명을 입력해 주세요. 예) (주)내기프트"
                              value={storeData.accountHolder || ''}
                              onChange={e => {
                                const value = e.target.value;
                                setStoreData(prev => ({
                                  ...prev,
                                  accountHolder: value,
                                }));
                              }}
                            />
                            <div
                              style={{
                                fontSize: 12,
                                color: '#d32f2f',
                                marginTop: 4,
                              }}
                            >
                              통장에 표시된 법인명으로 입력해 주세요.
                            </div>
                          </>
                        ) : (
                          <input
                            className="input_01"
                            type="text"
                            disabled
                            readOnly
                            value={
                              storeData.accountHolder ||
                              '계좌 실명 조회 후 자동 입력됩니다.'
                            }
                          />
                        )}
                      </div>
                      {accountHolderError && (
                        <div className="font_red">{accountHolderError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <p
                        style={{
                          margin: '4px 0 0',
                          fontSize: '13px',
                          color: '#e67e22',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        <span style={{ fontWeight: 700 }}>※</span>
                        <span style={{ color: '#e67e22' }}>
                          계좌 정보는{' '}
                          <strong
                            style={{
                              fontSize: 'inherit',
                              fontWeight: 700,
                              color: '#c0392b',
                            }}
                          >
                            계좌 실명 조회
                          </strong>
                          를 완료한 뒤 반드시{' '}
                          <strong
                            style={{
                              fontSize: 'inherit',
                              fontWeight: 700,
                              color: '#c0392b',
                            }}
                          >
                            저장 버튼
                          </strong>
                          까지 눌러야 최종 반영됩니다. (조회만 하고 저장하지
                          않으면 변경되지 않습니다.)
                        </span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeNaverUrl}</th>
                    <td>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          className="input_01"
                          type="text"
                          value={storeData.naverUrl || ''}
                          onChange={e =>
                            handleSocialUrlChange('naverUrl', e.target.value)
                          }
                        />
                        {storeData.naverUrl && (
                          <a
                            href={normalizeUrl(storeData.naverUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}
                            title={t.openLink}
                          >
                            <img
                              src={`${process.env.PUBLIC_URL || ''}/icons/naver.svg`}
                              alt="네이버 열기"
                              style={{ width: '20px', height: '20px' }}
                            />
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeKakaoUrl}</th>
                    <td>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          className="input_01"
                          type="text"
                          value={storeData.kakaoUrl || ''}
                          onChange={e =>
                            handleSocialUrlChange('kakaoUrl', e.target.value)
                          }
                        />
                        {storeData.kakaoUrl && (
                          <a
                            href={normalizeUrl(storeData.kakaoUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}
                            title={t.openLink}
                          >
                            <img
                              src={`${process.env.PUBLIC_URL || ''}/icons/kakao.svg`}
                              alt="카카오 열기"
                              style={{ width: '20px', height: '20px' }}
                            />
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeInstagramUrl}</th>
                    <td>
                      <div
                        style={{
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          className="input_01"
                          type="text"
                          value={storeData.instagramUrl || ''}
                          onChange={e =>
                            handleSocialUrlChange(
                              'instagramUrl',
                              e.target.value
                            )
                          }
                        />
                        {storeData.instagramUrl && (
                          <a
                            href={normalizeUrl(storeData.instagramUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}
                            title={t.openLink}
                          >
                            <img
                              src={`${process.env.PUBLIC_URL || ''}/icons/instagram.svg`}
                              alt="인스타그램 열기"
                              style={{ width: '20px', height: '20px' }}
                            />
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                  {/*
                  <tr>
                    <th>{t.pushalarm}</th>
                    <td>
                      <button
                        type="button"
                        onClick={pushAlarm}
                        className="button_05 button_black"
                      >
                        {t.pushalarm}
                      </button>
                    </td>
                  </tr>
                  */}
                  <tr>
                    <th>{t.storeQrStickerCount}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="number"
                          min={0}
                          inputMode="numeric"
                          placeholder="0"
                          style={{ maxWidth: '200px' }}
                          value={
                            storeData.qrStickerCount === null ||
                            storeData.qrStickerCount === undefined
                              ? ''
                              : storeData.qrStickerCount
                          }
                          onChange={e => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setStoreData({
                                ...storeData,
                                qrStickerCount: null,
                              });
                              return;
                            }
                            const n = parseInt(raw, 10);
                            setStoreData({
                              ...storeData,
                              qrStickerCount: Number.isFinite(n)
                                ? Math.min(999999, Math.max(0, n))
                                : null,
                            });
                          }}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.storeAcrylicInstallCount}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="number"
                          min={0}
                          inputMode="numeric"
                          placeholder="0"
                          style={{ maxWidth: '200px' }}
                          value={
                            storeData.acrylicInstallCount === null ||
                            storeData.acrylicInstallCount === undefined
                              ? ''
                              : storeData.acrylicInstallCount
                          }
                          onChange={e => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setStoreData({
                                ...storeData,
                                acrylicInstallCount: null,
                              });
                              return;
                            }
                            const n = parseInt(raw, 10);
                            setStoreData({
                              ...storeData,
                              acrylicInstallCount: Number.isFinite(n)
                                ? Math.min(999999, Math.max(0, n))
                                : null,
                            });
                          }}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.giftQR}</th>
                    <td>
                      <div className="signup_06">
                        <div className="signup_06_002 signup_06_002_qrbox signup_06_002_qrbox_wide">
                          {qrValue ? (
                            <div className={qrStyles.storeQrCardChannel}>
                              <div className={qrStyles.storeQrHeadChannel}>
                                <div
                                  className={qrStyles.storeQrHeadTextChannel}
                                >
                                  <div className={qrStyles.storeQrTitleChannel}>
                                    {qrSticker.storeName} {qrSticker.giftLabel}
                                  </div>
                                  <div
                                    className={qrStyles.storeQrScanTextChannel}
                                  >
                                    {qrSticker.scanText}
                                  </div>
                                </div>
                              </div>
                              <div
                                className={qrStyles.storeQrQrWrapChannel}
                                ref={qrDownloadRef}
                              >
                                <QRCodeCanvas
                                  value={qrValue}
                                  size={71}
                                  level="H"
                                />
                              </div>
                              <div className={qrStyles.storeQrFooterChannel}>
                                <p>{qrSticker.footerTitle}</p>
                                <ul
                                  className={qrStyles.storeQrFooterListChannel}
                                >
                                  {qrSticker.footerSteps.map((step, idx) => (
                                    <li key={step}>
                                      <span
                                        className={
                                          qrStyles.storeQrFooterStepChannel
                                        }
                                      >
                                        {idx + 1}
                                      </span>
                                      <p>{step}</p>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              {/* 인쇄 전용 고해상도 QR 원본 — 화면엔 안 보이고 인쇄 시 <img> 소스로만 쓰인다 */}
                              <div
                                ref={qrPrintSourceRef}
                                style={{
                                  position: 'absolute',
                                  width: 1,
                                  height: 1,
                                  overflow: 'hidden',
                                  opacity: 0,
                                  pointerEvents: 'none',
                                }}
                                aria-hidden="true"
                              >
                                <QRCodeCanvas
                                  value={qrValue}
                                  size={480}
                                  level="H"
                                />
                              </div>
                            </div>
                          ) : (
                            <p style={{ margin: 0, color: '#b91c1c' }}>
                              {language === 'en'
                                ? 'QR is unavailable. Please contact support.'
                                : 'QR 을 만들 수 없습니다. 고객센터로 문의해 주세요.'}
                            </p>
                          )}
                        </div>
                        <div className="button-container">
                          <a
                            href={`${Config.SHOPUSER_SERVER}${storeData.storeNo}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <button
                              type="button"
                              className="button_05 button_gray"
                              style={{ width: '300px' }}
                            >
                              {t.movetogiftpage}
                            </button>
                          </a>
                          {qrValue && (
                            <>
                              <button
                                type="button"
                                className="button_05 button_black"
                                onClick={handleDownloadQR}
                              >
                                {t.downloadQR}
                              </button>
                              <button
                                type="button"
                                className="button_05 button_gray"
                                onClick={handlePrintQR}
                              >
                                {t.printQR}
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.registrationDate}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          style={{ backgroundColor: '#ddd' }}
                          type="text"
                          disabled
                          value={regDttm || ''}
                        />
                      </form>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.modificationDate}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          style={{ backgroundColor: '#ddd' }}
                          type="text"
                          disabled
                          value={updDttm || ''}
                        />
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </article>

            <article className="button_box_01">
              <NavLink to={`/${storeNo}/gift-list`}>
                <button
                  type="button"
                  className="button_01 button_03 button_gray_line"
                >
                  {t.cancel}
                </button>
              </NavLink>
              <button
                type="button"
                className="button_01 button_03 button_red"
                onClick={() => modStore()}
              >
                {t.save}
              </button>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
